import { FC, useCallback, useEffect } from 'react';
import { GetLoanApplicationResponse } from 'api/typegen/client/application/get';
import { R } from 'config/app';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Loading from 'ui/components/LoanApplicationProcessLayout/Loading/Loading';
import LoanApplicationProcessLayout from 'ui/components/LoanApplicationProcessLayout';
import useLoanApplicationCheckStatusQuery from 'ui/hooks/useLoanApplicationCheckStatusQuery';
import useLoanApplicationQuery from 'ui/hooks/useLoanApplicationQuery';

const TinkLoadingScene: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: checkStatusData } = useLoanApplicationCheckStatusQuery(5000);
  const { loanApplication } = useLoanApplicationQuery(
    checkStatusData?.completed,
  );

  const navigateByResolution = useCallback(
    ({ resolution, resolutionDetail, status }: GetLoanApplicationResponse) => {
      if (resolution === 'APPROVED' && status === 'CLOSED') {
        navigate(R.FirstLoanFdfApplied);
        return;
      }

      if (resolution === 'APPROVED') {
        navigate(R.FirstLoanApprovedTink);
        return;
      }

      if (resolution === 'REJECTED') {
        navigate(R.FirstLoanRejectedTink);
        return;
      }

      if (
        resolution === 'MANUAL' &&
        resolutionDetail === 'PENDING_FAST_DELIVERY_FEE'
      ) {
        navigate(R.FirstLoanApprovedManual);
        return;
      }

      if (
        resolution === 'MANUAL' &&
        resolutionDetail === 'INTERNAL_BLACKLIST'
      ) {
        navigate(R.FirstLoanCancelled);
        return;
      }

      if (resolution === 'MANUAL') {
        navigate(R.FirstLoanPendingManual);
        return;
      }
    },
    [],
  );

  useEffect(() => {
    if (!checkStatusData?.completed) {
      return;
    }
    if (!loanApplication?.resolution) {
      return;
    }
    navigateByResolution(loanApplication);
  }, [loanApplication?.resolution, checkStatusData?.completed]);

  return (
    <LoanApplicationProcessLayout>
      <Loading
        title={t('tink_loading_title')}
        text={t('tink_loading_subtitle')}
      />
    </LoanApplicationProcessLayout>
  );
};

export default TinkLoadingScene;
